import React, { useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
import { Menu, MenuItem } from '@blueprintjs/core';
import { Button, Popover, Icons, Spinner } from '../';
export const DropdownButton = ({ label, // translation
width, // control the width of the dropdown
openPosition = 'bottom-left', icon, // left icon
loading = false, disabled = false, translationData = {
    buttonLabel: 'Export',
}, items, selectedItem, updateSelection, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const circleIcon = React.createElement(Icons, { iconName: "ic-ui-circle", fill: "#ababab" });
    if (!selectedItem) {
        selectedItem = { key: '', label: '', icon: circleIcon };
    }
    const row = ({ index, style }) => {
        const item = items[index];
        const isSelected = selectedItem.key === item.key;
        const { key, label, icon } = item;
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                updateSelection(item);
                setIsOpen(false);
            }
        };
        return (React.createElement("div", { style: style },
            React.createElement(MenuItem, { className: cx('dropdown_item', {
                    'dropdown_item--selected': isSelected,
                    'dropdown_item--empty': key === 'NullValue' || key === '',
                }), key: `dropdown-item-${key}`, text: label, icon: icon, shouldDismissPopover: true, onClick: () => updateSelection(item), onKeyPress: selectItemOnKeyPress, tabIndex: 0 })));
    };
    const createDropdownMenu = () => {
        const itemCount = items.length;
        const listHeight = itemCount < 10 ? itemCount * 40 : 300;
        return (React.createElement(Menu, null,
            React.createElement(List, { height: listHeight, width: width ? width : 190, itemSize: 40, itemCount: itemCount }, row)));
    };
    const handlePopoverToggle = () => {
        if (!isOpen) {
            setIsOpen(true);
        }
    };
    return (React.createElement("div", { className: "dropdown dropdown-button" },
        React.createElement(Popover, { popoverClassName: "dropdown_popover", position: openPosition, transitionDuration: 0, isOpen: isOpen, canEscapeKeyClose: false, onInteraction: !disabled && !loading ? handlePopoverToggle : undefined, onClose: () => setIsOpen(false), autoFocus: false },
            React.createElement(Button, { size: "m", style: 'primary', className: loading ? 'loading' : '', leftIcon: !loading ? icon : undefined, rightIcon: !loading ? (React.createElement(Icons, { iconName: "ic-ui-chevron-down-sm", className: "ic-ui-chevron-down-sm" })) : (React.createElement(Icons, { iconName: `ic-`, size: "24" })), "aria-label": translationData.buttonLabel, disabled: loading ? false : disabled }, loading ? (React.createElement(React.Fragment, null,
                React.createElement(Spinner, { loading: true, size: "s" }),
                React.createElement("span", { className: "button_text" }, label))) : (React.createElement("span", { className: "button_text" }, label))),
            React.createElement("div", { className: "dropdown_content" }, createDropdownMenu()))));
};
//# sourceMappingURL=DropdownButton.js.map